import React from "react";
import ReactEditor from "react-text-editor-kit";
import { Upload_Image_On_S3 } from "../../DAL/FileUpload/s3FileUpload";
import { picBaseUrl } from "../../config/config";

let theme_config = {
  "background-color": "transparent",
  "border-color": "#bebebe87",
  "text-color": "#fff",
  "toolbar-button-background": "transparent",
  "toolbar-text-color": "#ACACAC",
  "toolbar-button-hover-background": "#0a0a0a",
  "toolbar-button-selected-background": "#bebebe87",
  "svg-color": "#ACACAC",
  "save-button-background": "#transparent",
};

/**
 * Editor
 *
 * A customizable rich text editor component using `react-text-editor-kit`,
 * with support for image uploads to AWS S3.
 *
 * Props:
 * - value (string): Current content of the editor.
 * - onChange (function): Function to handle editor content changes.
 * - height (string | number): Desired height for the editor (passed implicitly to styling).
 * - placeholder (string): Placeholder text shown when editor is empty.
 *
 * Notes:
 * - `theme_config` is used to customize the appearance of the editor and toolbar.
 * - `image_handler` manages uploading images via `Upload_Image_On_S3` and returns a public image URL.
 */
export default function Editor({ value, onChange, height, placeholder = "" }) {
  const get_editor_ref = (value) => {};

  const image_handler = async (e) => {
    const formData = {
      image: e.image,
    };

    try {
      let result = await Upload_Image_On_S3(formData);
      if (result.code === 200) {
        return picBaseUrl + result.path;
      } else {
        return "";
      }
    } catch (error) {
      return "";
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <ReactEditor
        value={value}
        getEditorRef={get_editor_ref}
        onChange={onChange}
        mainProps={{ className: "red" }}
        placeholder={placeholder}
        theme_config={theme_config}
        image_handler={image_handler}
      />
    </div>
  );
}
